import { useEffect, useState } from "react";

import { useSearchParams } from "react-router-dom";

import axios from "axios";

import jsPDF from "jspdf";

import { Download, CheckCircle2, CalendarDays, Hotel, ReceiptText, ArrowRight, Home, BookOpen, ShieldCheck, LockKeyhole, X, UserRound, Mail, Users, BedDouble } from "lucide-react";



export default function PaymentSuccess({ onLoginClick }) {



    const [searchParams] = useSearchParams();

    const orderId = searchParams.get("order_id");



    const [booking, setBooking] = useState(null);



    // const calculateCharges = (base) => {

    //     const serviceCharge = base * SERVICE_CHARGE;

    //     const vat = base * VAT;

    //     const tourismFee = TOURISM_FEE;



    const calculateCharges = (base) => {

        const serviceCharge = base * SERVICE_CHARGE;

        const vat = base * VAT;



        const tourismFee = getTourismFee();



        const total = base + serviceCharge + vat + tourismFee;



        return {

            base: Math.round(base),

            serviceCharge: Math.round(serviceCharge),

            vat: Math.round(vat),

            tourismFee: Math.round(tourismFee),

            total: Math.round(total)

        };

    };



    // const SERVICE_CHARGE = 0.10;

    // const VAT = 0.05;

    // const TOURISM_FEE = 10;



    const SERVICE_CHARGE = 0.10;

    const VAT = 0.05;



    const getTourismFee = () => {

        return Number(booking?.hotel?.rating) === 5 ? 20 : 10;

    };



    useEffect(() => {

        if (!orderId) return;



        axios.get(`https://cheapdubaihotels.com/api/verify-payment/${orderId}`)

            .then(res => {

                if (res.data.booking) {

                    setBooking(res.data.booking);

                }



                if (res.data.status === "pending") {

                    setTimeout(() => window.location.reload(), 2000);

                }

            })

            .catch(err => console.error(err));



    }, [orderId]);



    const formatDate = (date) => {

        return new Intl.DateTimeFormat("en-GB", {

            timeZone: "Asia/Dubai",

            day: "2-digit",

            month: "short",

            year: "numeric"

        }).format(new Date(date));

    };



    const getNights = () => {

        if (!booking) return 1;



        if (booking.nights) return booking.nights;



        const start = new Date(booking.check_in);

        const end = new Date(booking.check_out);



        const diff =

            Math.ceil((end - start) / (1000 * 60 * 60 * 24));



        return diff > 0 ? diff : 1;

    };



    const nightlyRate = () => {

        return booking?.discount_price || booking?.room_price || 0;

    };




    const getWebsiteName = () => {
        const hostname = window.location.hostname
            .replace(/^www\./, "")
            .replace(/\.(com|net|org|ae|co\.uk|co\.in)$/i, "");

        return hostname
            .replace(/[-_]/g, " ")
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    const websiteName = getWebsiteName();




    const downloadInvoice = () => {
        if (!booking) return;

        const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
        const W = 210;
        const margin = 18;
        const contentW = W - margin * 2;
        const blue = [11, 110, 142];
        const navy = [18, 54, 73];
        const orange = [255, 90, 31];
        const gold = [247, 185, 40];
        const muted = [103, 119, 133];
        const border = [224, 233, 239];
        const light = [248, 250, 252];
        const white = [255, 255, 255];
        const safe = (value) => String(value ?? "-");
        const money = (amount) => `AED ${Number(amount || 0).toLocaleString("en-AE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        const nights = getNights();
        const base = Number(booking.final_nightly_price || booking.room_price || 0);
        const charges = calculateCharges(base);
        const totalPaid = charges.total * nights;
        const orderReference = safe(booking.order_id || orderId);
        const roomName = safe(booking.room_name);
        const tourismLabel = Number(booking?.hotel?.rating) === 5 ? "Tourism Fee (5-star hotel)" : "Tourism Fee";

        const write = (value, x, y, size = 10, color = navy, weight = "normal", opts = {}) => {
            doc.setFont("helvetica", weight);
            doc.setFontSize(size);
            doc.setTextColor(...color);
            doc.text(safe(value), x, y, opts);
        };
        const rule = (y) => {
            doc.setDrawColor(...border);
            doc.setLineWidth(0.3);
            doc.line(margin, y, W - margin, y);
        };
        const infoLine = (label, value, x, y, width = 77) => {
            write(label.toUpperCase(), x, y, 7.5, muted, "bold");
            const lines = doc.splitTextToSize(safe(value), width);
            write(lines.slice(0, 2), x, y + 6, 10, navy, "bold");
            return y + 6 + Math.max(1, Math.min(lines.length, 2)) * 4.5;
        };

        // Branded header
        doc.setFillColor(...blue);
        doc.rect(0, 0, W, 49, "F");
        doc.setFillColor(...gold);
        doc.rect(0, 49, W, 2, "F");
        write(websiteName.toUpperCase(), margin, 18, 17, white, "bold");
        write("Hotel booking receipt", margin, 27, 9, [226, 241, 247]);
        write("PAYMENT RECEIPT", W - margin, 17, 11, white, "bold", { align: "right" });
        write(`Issued: ${formatDate(new Date())}`, W - margin, 27, 8.5, [226, 241, 247], "normal", { align: "right" });

        // Status and reference
        doc.setFillColor(236, 249, 242);
        doc.roundedRect(margin, 60, contentW, 23, 3, 3, "F");
        write("PAYMENT SUCCESSFUL", margin + 7, 69, 11, [24, 117, 77], "bold");
        write("Your hotel booking is confirmed.", margin + 7, 76, 8.5, [66, 108, 91]);
        write("ORDER REFERENCE", margin, 95, 8, muted, "bold");
        write(orderReference, margin, 102, 12, navy, "bold");
        write("RECEIPT DATE", W - margin, 95, 8, muted, "bold", { align: "right" });
        write(formatDate(new Date()), W - margin, 102, 10, navy, "bold", { align: "right" });
        rule(110);

        // Guest and reservation details
        write("GUEST DETAILS", margin, 121, 11, blue, "bold");
        write("RESERVATION DETAILS", 110, 121, 11, blue, "bold");
        let guestY = 131;
        guestY = infoLine("Guest name", booking.name, margin, guestY);
        guestY = infoLine("Email", booking.email, margin, guestY + 6, 79);
        guestY = infoLine("Guests", booking.guests, margin, guestY + 6);
        let hotelY = 131;
        hotelY = infoLine("Hotel", booking.hotel_name, 110, hotelY, 77);
        hotelY = infoLine("Room type", roomName, 110, hotelY + 6);
        hotelY = infoLine("Room number", booking.room_number || booking.room?.room_number || "-", 110, hotelY + 6);
        const detailsBottom = Math.max(guestY, hotelY) + 7;
        rule(detailsBottom);
        const datesY = detailsBottom + 12;
        infoLine("Check-in", formatDate(booking.check_in), margin, datesY, 46);
        infoLine("Check-out", formatDate(booking.check_out), 81, datesY, 46);
        infoLine("Nights", nights, 151, datesY, 35);

        // Pricing table, retaining the application's existing rounding logic
        let y = datesY + 25;
        doc.setFillColor(...blue);
        doc.roundedRect(margin, y, contentW, 12, 2, 2, "F");
        write("PAYMENT BREAKDOWN", margin + 5, y + 8, 10, white, "bold");
        write("AMOUNT", W - margin - 5, y + 8, 9, white, "bold", { align: "right" });
        y += 20;
        const item = (label, amount, emphasize = false) => {
            if (emphasize) {
                doc.setFillColor(...light);
                doc.rect(margin, y - 6, contentW, 12, "F");
            }
            write(label, margin + 5, y, 9, navy, emphasize ? "bold" : "normal");
            write(money(amount), W - margin - 5, y, 9, navy, emphasize ? "bold" : "normal", { align: "right" });
            y += 11;
        };
        item("Room price (per night)", base);
        item(`Room price total (${nights} night${nights === 1 ? "" : "s"})`, base * nights);
        item("Service charge (10%) per night", charges.serviceCharge);
        item("VAT (5%) per night", charges.vat);
        item(`${tourismLabel} per night`, charges.tourismFee);
        item("Total per night", charges.total, true);
        if (booking.discount_price) {
            item("Discounted rate (as recorded)", Number(booking.discount_price));
        }
        rule(y + 1);
        y += 10;
        doc.setFillColor(...navy);
        doc.roundedRect(margin, y - 5, contentW, 19, 3, 3, "F");
        write("TOTAL PAID", margin + 6, y + 6, 12, white, "bold");
        write(money(totalPaid), W - margin - 6, y + 6, 13, gold, "bold", { align: "right" });
        y += 25;


        // Footer on the same page if possible; otherwise start a new page
        if (y > 245) {
            doc.addPage();
            y = 25;
        }

        write(
            `Thank you for booking with ${websiteName}.`,
            margin, y, 10, blue, "bold"
        );

        y += 8;
        write(
            "Email: info@southtravels.com",
            margin, y, 8.5, muted
        );

        y += 6;
        write(
            "Phone: +971 4 447 3839",
            margin, y, 8.5, muted
        );

        y += 6;
        write(
            "WhatsApp: +971 50 247 7593",
            margin, y, 8.5, muted
        );

        y += 8;
        write(
            "Please retain this receipt for your records.",
            margin, y, 8.5, muted
        );

        // Bottom footer
        const footerY = 285;

        doc.setDrawColor(...border);
        doc.line(margin, footerY - 7, W - margin, footerY - 7);

        write(
            window.location.hostname.replace(/^www\./, ""),
            margin, footerY, 8, muted
        );

        write(
            "Hotel booking receipt",
            W - margin, footerY, 8, muted,
            "normal", { align: "right" }
        );

        const fileReference = orderReference.replace(
            /[^a-zA-Z0-9_-]/g, "-"
        );

        doc.save(`hotel-booking-receipt-${fileReference}.pdf`);
    };


    const formatCurrency = (amount) =>

        new Intl.NumberFormat("en-AE", {

            style: "currency",

            currency: "AED"

        }).format(amount);



    const [showLoginPopup, setShowLoginPopup] = useState(false);



    const handleMyBookingsClick = () => {

        const user = JSON.parse(localStorage.getItem("user"));



        if (!user) {

            setShowLoginPopup(true);

            return;

        }



        window.location.href = "/profile";

    };





    const getFinalNightlyRate = () => {

        const base = Number(booking?.final_nightly_price || booking?.room_price || 0);



        const serviceCharge = base * SERVICE_CHARGE;

        const vat = base * VAT;



        // return base + serviceCharge + vat + TOURISM_FEE;

        return base + serviceCharge + vat + getTourismFee();

    };



    const getBasePrice = () => {

        return Number(booking?.final_nightly_price || booking?.room_price || 0);

    };

    const base = getBasePrice();

    const nights = getNights();

    const b = calculateCharges(base);











    const details = [
        { label: "Name", value: booking?.name, icon: UserRound },
        { label: "Email", value: booking?.email, icon: Mail },
        { label: "Hotel", value: booking?.hotel_name, icon: Hotel },
        { label: "Room", value: booking?.room_name, icon: BedDouble },
        { label: "Room Details", value: booking?.room_number || "-", icon: BedDouble },
        { label: "Guests", value: booking?.guests, icon: Users },
        { label: "Check-in", value: booking ? formatDate(booking.check_in) : "", icon: CalendarDays },
        { label: "Check-out", value: booking ? formatDate(booking.check_out) : "", icon: CalendarDays },
        { label: "Nights", value: nights, icon: CalendarDays },
        { label: "Rate Per Night", value: `AED ${Math.round(base)} × ${nights} night(s)`, icon: ReceiptText },
    ];

    return (
        <main className="min-h-screen bg-[#F8FAFC] pt-16 text-slate-800">
            <section className="relative overflow-hidden bg-[#0B6E8E] px-5 pb-24 pt-16 text-center sm:pb-28 sm:pt-20">
                <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-[#F7B928]/15 blur-3xl" />
                <div className="pointer-events-none absolute -right-20 bottom-0 h-80 w-80 rounded-full bg-[#FF5A1F]/15 blur-3xl" />
                <div className="relative mx-auto max-w-3xl">
                    <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-[24px] border border-white/25 bg-white/15 shadow-xl backdrop-blur-sm">
                        <CheckCircle2 className="h-11 w-11 text-[#F7B928]" strokeWidth={1.8} />
                    </div>
                    <div className="mt-6 text-xs font-extrabold uppercase tracking-[0.24em] text-[#F7B928]">Booking confirmation</div>
                    <h1 className="mt-3 text-3xl font-black tracking-tight !text-white sm:text-5xl">Payment Successful</h1>
                    <p className="mx-auto mt-4 max-w-xl text-sm leading-7 text-white/80 sm:text-base">Your booking is confirmed. We’ll contact you shortly.</p>
                    {orderId && <p className="mt-5 inline-flex max-w-full break-all rounded-full border border-white/20 bg-white/10 px-5 py-2 text-xs font-semibold text-white/90">Order ID: {orderId}</p>}
                </div>
            </section>

            <div className="relative mx-auto -mt-12 max-w-[1200px] px-4 pb-20 sm:px-6 lg:px-8" id="booking-card">
                {!booking ? (
                    <div className="rounded-[28px] border border-slate-100 bg-white px-6 py-20 text-center shadow-[0_18px_55px_rgba(11,110,142,0.10)]">
                        <div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-[#0B6E8E]/20 border-t-[#FF5A1F]" />
                        <p className="mt-5 font-semibold text-[#0B6E8E]">Loading booking details...</p>
                    </div>
                ) : (
                    <div className="grid items-start gap-7 lg:grid-cols-[1.1fr_0.9fr]">
                        <section className="overflow-hidden rounded-[28px] border border-slate-100 bg-white shadow-[0_18px_55px_rgba(11,110,142,0.09)]">
                            <div className="h-1.5 bg-gradient-to-r from-[#FF5A1F] via-[#F7B928] to-[#0B6E8E]" />
                            <div className="p-6 sm:p-9">
                                <div className="flex items-center gap-3">
                                    <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#0B6E8E]/10 text-[#0B6E8E]"><Hotel size={23} /></span>
                                    <div><p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#FF5A1F]">Your reservation</p><h2 className="text-2xl font-extrabold text-[#0B6E8E]">Booking Details</h2></div>
                                </div>
                                <div className="mt-7 divide-y divide-slate-100">
                                    {details.map(({ label, value, icon: Icon }) => (
                                        <div key={label} className="flex flex-col gap-2 py-4 sm:flex-row sm:items-center sm:justify-between sm:gap-5">
                                            <span className="flex items-center gap-2.5 text-sm font-medium text-slate-500"><Icon size={16} className="shrink-0 text-[#0B6E8E]" />{label}</span>
                                            <span className="break-words text-sm font-bold text-slate-800 sm:max-w-[60%] sm:text-right">{value}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </section>

                        <section className="overflow-hidden rounded-[28px] border border-slate-100 bg-white shadow-[0_18px_55px_rgba(11,110,142,0.09)]">
                            <div className="bg-[#0B6E8E] p-6 text-white sm:p-8">
                                <div className="flex items-center gap-3"><ReceiptText className="text-[#F7B928]" size={26} /><h2 className="text-2xl font-extrabold !text-white">Price Breakdown</h2></div>
                                <p className="mt-2 text-sm text-white/75">Your booking payment summary in AED</p>
                            </div>
                            <div className="p-6 sm:p-8">
                                <div className="space-y-4 text-sm">
                                    {[
                                        ["Base Price", `AED ${b.base}`],
                                        ["Service Charge (10%)", `AED ${b.serviceCharge}`],
                                        ["VAT (5%)", `AED ${b.vat}`],
                                        [`Tourism Fee${Number(booking?.hotel?.rating) === 5 ? " (5★ Hotel)" : ""}`, `AED ${b.tourismFee}`],
                                    ].map(([label, value]) => <div key={label} className="flex justify-between gap-4"><span className="text-slate-500">{label}</span><span className="font-bold text-[#0B6E8E]">{value}</span></div>)}
                                    <div className="flex justify-between gap-4 border-t border-slate-100 pt-4"><span className="font-bold text-slate-700">Total Per Night</span><span className="font-extrabold text-[#0B6E8E]">AED {b.total}</span></div>
                                    {booking.discount_price && <div className="flex justify-between gap-4 rounded-xl bg-green-50 px-4 py-3 text-green-700"><span className="font-semibold">Discounted</span><span className="font-extrabold">AED {Math.round(Number(booking.discount_price))}</span></div>}
                                    <div className="flex justify-between gap-4"><span className="text-slate-500">Nights</span><span className="font-bold">{getNights()}</span></div>
                                    <div className="flex justify-between gap-4"><span className="text-slate-500">Price Calculation</span><span className="text-right font-bold">AED {Math.round(Number(getFinalNightlyRate()))} × {getNights()} night(s)</span></div>
                                </div>
                                <div className="mt-7 rounded-2xl bg-[#0B6E8E] p-5 text-white">
                                    <p className="text-xs font-bold uppercase tracking-[0.15em] text-white/70">Total Paid</p>
                                    <p className="mt-2 text-3xl font-black !text-white">AED {Math.round(b.total * nights)}</p>
                                </div>
                                <p className="mt-4 text-xs leading-6 text-slate-500">ℹ Tourism fee applied: AED {getTourismFee()}{Number(booking?.hotel?.rating) === 5 ? " for 5★ hotel" : " standard hotel fee"}</p>
                                <div className="mt-7 grid gap-3 sm:grid-cols-2">
                                    <button type="button" onClick={() => (window.location.href = "/")} className="flex items-center justify-center gap-2 rounded-xl border border-[#0B6E8E]/20 px-4 py-3 text-sm font-bold text-[#0B6E8E] transition hover:bg-[#0B6E8E]/5"><Home size={17} /> Home</button>
                                    <button type="button" onClick={handleMyBookingsClick} className="flex items-center justify-center gap-2 rounded-xl border border-[#0B6E8E]/20 px-4 py-3 text-sm font-bold text-[#0B6E8E] transition hover:bg-[#0B6E8E]/5"><BookOpen size={17} /> My Bookings</button>
                                </div>
                                <button type="button" onClick={downloadInvoice} className="mt-3 flex w-full items-center justify-center gap-2 rounded-xl bg-[#FF5A1F] px-5 py-4 text-sm font-extrabold text-white shadow-lg shadow-orange-500/15 transition hover:bg-[#e94b14]"><Download size={18} /> Download Receipt <ArrowRight size={16} /></button>
                                <p className="mt-5 flex items-center justify-center gap-2 text-center text-xs text-slate-500"><ShieldCheck size={15} className="text-[#0B6E8E]" /> Secure booking confirmation</p>
                            </div>
                        </section>
                    </div>
                )}
            </div>

            {showLoginPopup && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-950/65 p-4 backdrop-blur-sm" role="dialog" aria-modal="true" aria-labelledby="login-dialog-title">
                    <div className="relative w-full max-w-md rounded-[28px] bg-white p-7 text-center shadow-2xl sm:p-9">
                        <button type="button" aria-label="Close" onClick={() => setShowLoginPopup(false)} className="absolute right-5 top-5 text-slate-400 hover:text-slate-700"><X size={20} /></button>
                        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-[#0B6E8E]/10 text-[#0B6E8E]"><LockKeyhole size={30} /></div>
                        <h3 id="login-dialog-title" className="mt-5 text-2xl font-extrabold text-[#0B6E8E]">Login Required</h3>
                        <p className="mt-3 text-sm leading-7 text-slate-500">You need to login or create an account to view and manage your bookings.</p>
                        <div className="mt-7 space-y-3">
                            <button type="button" onClick={() => { setShowLoginPopup(false); onLoginClick(); }} className="w-full rounded-xl bg-[#0B6E8E] px-5 py-3.5 font-bold text-white hover:bg-[#095b77]">Login</button>
                            <button type="button" onClick={() => { setShowLoginPopup(false); onLoginClick(); }} className="w-full rounded-xl border-2 border-[#0B6E8E] px-5 py-3.5 font-bold text-[#0B6E8E] hover:bg-[#0B6E8E]/5">Create Account</button>
                            <button type="button" onClick={() => setShowLoginPopup(false)} className="w-full py-2 text-sm font-semibold text-slate-400 hover:text-slate-600">Cancel</button>
                        </div>
                    </div>
                </div>
            )}
        </main>
    );
}
